import comp from "./ButtonCard";
export default comp;
